<script setup lang="ts">
import { ref, onBeforeMount } from 'vue';
const route = useRoute();

const { isDarkTheme } = useDarkTheme();
const { permission } = useNotifications()

import Loading from '~/components/loading.vue';
import VerifyEmail from './components/verify-email.vue';
import Sidebar from './components/sidebar.vue';
import MobileDownload from '~/components/layout/mobile-download.vue';
import PageHeader from '~/components/page-header.vue';

defineProps({
  fluid: {
    type: Boolean,
    default: true,
  },
});


const layoutStore = useLayoutStore();
const { initializeStores } = useStoreInitialization();

onBeforeMount(() => {
  initializeStores();
})

</script>

<template>

  <div v-if="!layoutStore.boot" class="h-screen overflow-hidden flex bg-white dark:bg-zinc-800">
    <Loading />
  </div>

  <MobileDownload v-if="layoutStore.boot" />

  <VerifyEmail />

  <div v-if="layoutStore.boot" class="hidden sm:block h-screen overflow-hidden bg-white dark:bg-zinc-800 w-full relative">
    <div :class="[
      'absolute inset-y-0 left-0 z-10 transition-transform duration-300 ease-in-out',
      layoutStore.sidebarOpen ? 'translate-x-0' : '-translate-x-full'
    ]">
      <Sidebar />
    </div>
    <div :class="[
      'h-full flex flex-col transition-all duration-300 ease-in-out',
      layoutStore.sidebarOpen ? 'ml-52 2xl:ml-56' : 'ml-0'
    ]">
      <PageHeader v-if="$slots.header">
        <slot name="header" />
      </PageHeader>
      <div class="flex flex-1 overflow-hidden">
        <slot name="sidebar" />
        <div class="flex-1 overflow-auto">
          <div :class="{'w-full h-full': fluid, 'mx-auto max-w-3xl p-6': !fluid}">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>